import React, { FunctionComponent } from 'react'
import useTranslation from '../../hooks/useTranslation'
import SummaryData from '../../entities/SummaryData'
import OverviewEquipmentGroups from '../overview-equipment-groups'
import DisclaimerText from '../disclaimer-text'
import style from './overviewView.css'
import { OrderKey } from '../../entities/ConfigurationResponse'
import SummaryTable from '../summary-table'
import LoadingIndicatorWrapper from '../loading-indicator-wrapper'
import ExpandableText from '../expandable-text'
import OrderKeyFormatted from '../order-key-formatted/OrderKeyFormatted'
import { ROUTE_OVERVIEW } from '../../constants/routes'

export type Props = {
    summary: SummaryData
    carlineTitle: string
    loadSummaryData: Function
    orderKey: OrderKey
    isLoading: boolean
    aveString: string
    showAveString: boolean
}

const OverviewView: FunctionComponent<Props> = (props) => {
    const {
        summary,
        carlineTitle,
        loadSummaryData,
        orderKey,
        isLoading,
        aveString,
        showAveString,
    } = props
    const { t } = useTranslation()

    const envkvLabelObject = summary.envkvLabelUrl
        ?
            <div className={style.envkvLabelWrapper} data-testid='envkv-label'>
                <img alt="" className={style.envkvLabelImage} src={summary.envkvLabelUrl
                }/>
            </div>
        : null

    const aveStringElement = showAveString
        ? <ExpandableText title={t('overview.aveString')} text={aveString} charLimit={800}/>
        : null

    return (
        <>
            <div className="contentWithCartboxContainer">
                <div className="contentWithCartbox">
                    <div data-testid={`page-${ROUTE_OVERVIEW}`}>
                        <LoadingIndicatorWrapper isLoading={isLoading}>
                            <h1>{t('overview.heading')}</h1>
                            <h2 className={style.subTitle}>{carlineTitle}</h2>
                            <SummaryTable summary={summary} loadSummaryData={loadSummaryData} />
                            {envkvLabelObject}
                            {aveStringElement}
                            <OrderKeyFormatted orderKey={orderKey} />
                            <OverviewEquipmentGroups />
                        </LoadingIndicatorWrapper>
                        <DisclaimerText remarks={summary.remarks} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default OverviewView
